// Shared shape for the Application UI (branding) config form.
// The `configuration` payload persisted per UICustomization record — see NG-8455 / NG-8454.

// Slots audited against the actual Login & RegisterV3 pages (NG-8455). Each maps to a theme
// token in uiConfig.slots.ts — that map is the single source of truth for defaults and for
// FE-App/FE-Preview (NG-8456/8457).
//
// NG-8572 removed the left branding panel from every public page, so the `brandingPanelBg` /
// `brandingPanelText` slots were retired — they styled nothing on screen and only invited tenants
// to configure a surface that no longer renders. Stored configs may still carry them; the mappers
// drop unknown slots on hydrate so they don't get written back.
export const COLOR_SLOTS = [
    "primaryActionBg",
    "primaryActionText",
    "secondaryActionBg",
    "secondaryActionText",
    "secondaryActionBorder",
    "links",
    "bodyText",
    "secondaryText",
    "formBackground",
    "inputBorder",
    "disabledButtonBg",
    "errorColor",
    "successColor",
] as const;

export type ColorSlot = (typeof COLOR_SLOTS)[number];

// Imperative handle exposed by CollapsibleCard so a parent can drive expand/collapse
// (e.g. expand offending sections on submit, or collapse nested sections when a parent closes).
export interface CollapsibleCardHandle {
    isExpanded: () => boolean;
    expand: () => void;
    // Validates the subtree first and refuses to close while invalid.
    collapse: () => void;
}

export type ThemeColors = Record<ColorSlot, string>;

export enum AppearanceTheme {
    LIGHT = "light",
    DARK = "dark",
    SYSTEM = "system",
}

export interface MessageContent {
    title: string;
    subtitle: string;
    description: string;
}

export interface TApplicationUIConfigForm {
    isEnabled: boolean;
    defaultMode: AppearanceTheme;
    content: {
        login: MessageContent;
        registration: MessageContent;
    };
    colors: {
        light: ThemeColors;
        dark: ThemeColors;
    };
}
